import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { useQuery } from "react-query";
import { useNavigate } from "react-router-dom";
//prime React
import { Button } from "primereact/button";
import { Tooltip } from "primereact/tooltip";
import { RadioButton } from "primereact/radiobutton";
//components
import Select from "../../../../components/input/Select";
import NumberInput from "../../../../components/input/NumberInput";
import ModalCommisionGeral from "../../../Commission/ModalCommission/ModalCommisionGeral";
import ModalCreateCurrentAccount from "../../../Settings/CurrentAccount/ModalCreateCurrentAccount";
//services
import { getAccounts } from "../../../../services/Banks/getAccounts";
import { patchTypeBillet } from "../../../../services/Banks/patchTypeBillet";
import { getAccountDiscount } from "../../../../services/Banks/getAccountDiscount";
import { postAccountDiscount } from "../../../../services/Banks/postAccountDiscount";
import { banks } from "../../../../utils/banks";
import { getOwner } from "../../../../services/GlobalRoles/getOwner";
import { useAppContext } from "../../../../context/AppContext";
import { patchCommissionsGeral } from "../../../../services/Commissions/patchCommissionsGeral";

export default function Finance({ id, state, setActiveIndex }) {
  const { permissions } = useAppContext();
  const navigate = useNavigate();
  const form = useForm();
  const errors = form.formState.errors;
  const setValue = form.setValue;
  const [loading, setLoading] = useState(false);
  const [radioButton, setRadioButton] = useState("1");
  const [accountDropdown, setAccountDropdown] = useState([]);
  const [createAccVisible, setCreateAccVisible] = useState(false);
  const [loadingCreateAcc, setLoadingCreateAcc] = useState(false);
  const [isModalVisible, setModalVisible] = useState(false);
  const [commissionData, setCommissionData] = useState(null);
  const {
    data: accounts,
    isLoading: loadingAccounts,
    refetch: refetchAccs,
  } = useQuery({
    queryKey: ["accounts"],
    queryFn: () => getAccounts(),
    enabled: !!permissions?.includes("145"),
  });

  const { data: discountData, isLoading: loadingDiscData } = useQuery({
    queryKey: [`discountData${id}`],
    queryFn: () => getAccountDiscount(id),
    enabled: !!permissions?.includes("16"),
  });

  const { data: owners } = useQuery(["owners"], () => getOwner(), {
    enabled: !!createAccVisible || !!permissions?.includes("59"),
  });

  useEffect(() => {
    if (discountData) {
      setRadioButton(
        discountData.typeDiscount ? discountData.typeDiscount.toString() : "1"
      );
      setValue("current_account_id", discountData.currentAccountInUse);
      setValue("percent", discountData.percent);
      setValue("value_discount", discountData.valueDiscount);

      setValue(
        "days_discount_payment_slip",
        discountData.days_discount_payment_slip
      );
      setValue("late_fee", discountData.late_fee);
      setValue("late_interest", discountData.late_interest);
      setValue("enable_mode_a4", discountData.enable_mode_a4);
      setValue("value_commission", discountData.percentage_commission);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [discountData]);

  useEffect(() => {
    if (accounts) {
      console.log(accounts);
      const allowedBanks = [
        "001",
        "033",
        "041",
        "748",
        "756",
        "422",
        "341",
        "104",
        "237",
        "999",
      ];
      const accountDropdownAdjust = accounts
        .filter((a) => allowedBanks.includes(a.bank)) // Filtra os bancos permitidos
        .map((a) => {
          const bank = banks.find(
            (i) => parseInt(i.value) === parseInt(a.bank)
          );
          return {
            value: a.id,
            label: `${bank.label} | Agência: ${a.agency} - ${a.agency_digit} | Conta: ${a.account_number} - ${a.account_digit}`,
          };
        });
      setAccountDropdown(accountDropdownAdjust);
    }
  }, [accounts]);

  const onDiscountSubmit = async (data) => {
    setLoading(true);
    const notification = toast.loading("Por favor aguarde...");

    const sendData = {
      enterprise_id: parseInt(id),
      late_fee: data.late_fee,
      late_interest: data.late_interest,
      current_account_id: data.current_account_id,
      type_discount: parseInt(radioButton),
      value_discount: data.value_discount ? data.value_discount : 0,
      days_discount_payment_slip: data.days_discount_payment_slip
        ? data.days_discount_payment_slip
        : 0,
      percentage_transfer_installment: 0,
      percentage_commission: data.value_commission,
    };

    const response = await postAccountDiscount(sendData);
    if (response.success) {
      toast.update(notification, {
        render: response.success,
        autoClose: 5000,
        type: "success",
        isLoading: false,
      });
      setActiveIndex(1);
    } else {
      toast.update(notification, {
        render: "Oops, algo deu errado. Tente novamente!",
        autoClose: 5000,
        type: "error",
        isLoading: false,
      });
    }
    setLoading(false);
  };

  const setTypeBillet = async (data) => {
    if (data === undefined) {
      return;
    }
    const sendData = {
      empId: id,
      typeBillet: { status: data },
    };
    await patchTypeBillet(sendData);
  };
  const handleBlur = async (value) => {
    const notification = toast.loading("Por favor aguarde...");
    try {
      const numericValue = parseFloat(value);
      const sendData = {
        enterprise_id: parseInt(id),
        percentage: numericValue,
        type_commission: "valor_venda",
      };

      const response = await patchCommissionsGeral(sendData);

      if (response.success) {
        toast.update(notification, {
          render: response.success,
          autoClose: 5000,
          type: "success",
          isLoading: false,
        });
      } else {
        toast.update(notification, {
          render: "Oops, algo deu errado. Tente novamente!",
          autoClose: 5000,
          type: "error",
          isLoading: false,
        });
      }
    } catch (error) {
      console.error("Erro no patchCommissionsGeral:", error);
      toast.update(notification, {
        render: "Erro ao atualizar a comissão. Tente novamente mais tarde.",
        autoClose: 5000,
        type: "error",
        isLoading: false,
      });
    }
  };

  return (
    <>
      <form onSubmit={form.handleSubmit(onDiscountSubmit)}>
        <div className="d-flex align-items-center mt-2">
          <h3 className="vertical-align-middle text-success">
            Conta de Recebimento da Empresa{" "}
            <Tooltip target=".custom-target-icon" />
            <i
              className="custom-target-icon pi pi-info-circle mx-2 p-text-secondary"
              data-pr-tooltip="Configurar contas homologadas para geração de boletos."
              style={{ cursor: "pointer" }}
            ></i>
          </h3>
        </div>
        <div className="row">
          <div className=" col-xl-3 col-lg-3 col-md-6 col-12">
            <Select
              control={form.control}
              errors={form.errors}
              options={accountDropdown}
              isRequired={true}
              disabled={loadingAccounts ? true : false}
              label={loadingAccounts ? "Carregando..." : "Conta de Recebimento"}
              name="current_account_id"
            />
          </div>
          <div className="col-xl-3 col-lg-3 col-md-6 col-12">
            <Select
              control={form.control}
              errors={form.errors}
              isRequired={true}
              options={[
                { value: 1, label: "Boleto A4" },
                { value: 0, label: "Carnê" },
              ]}
              label={loadingDiscData ? "Carregando..." : "Formato de Boleto"}
              name="enable_mode_a4"
              onChange={(e) => setTypeBillet(e)}
            />
          </div>
          {permissions?.includes("145") && (
            <div className="col-xl-3 col-lg-3 col-md-6 col-12 pt-1">
              <Button
                loading={loadingCreateAcc}
                rounded
                type="button"
                label="Nova Conta"
                icon="fa fa-plus"
                onClick={() =>
                  navigate(`/banks/${id}`, {
                    state: { name: state ? state.name : "Empreendimento" },
                  })
                }
                className="p-inputtext-sm mt-3 w-100"
              />
            </div>
          )}
        </div>
        <div className="flex align-items-center mt-5">
          <h3 className="vertical-align-middle text-success">
            Encargos <i className="bi bi-currency-exchange"></i>
          </h3>
        </div>
        <div className="row">
          <div>
            <p>
              Configurações de taxas e juros
              <Tooltip target=".custom-target-icon" />
              <i
                className="custom-target-icon pi pi-info-circle mx-2 p-text-secondary"
                data-pr-tooltip="Configurações de multa e mora por atraso."
                style={{ cursor: "pointer" }}
              ></i>
            </p>
          </div>

          <div className="row">
            <div className="col-lg-3 col-md-6">
              <NumberInput
                name="late_fee"
                max={100}
                suffix="%"
                errors={errors}
                disabled={loadingDiscData}
                required={true}
                placeholder="0%"
                label={loadingDiscData ? "Carregando..." : "Multa Atraso"}
                minFractionDigits={2}
                maxFractionDigits={2}
                control={form.control}
              />
            </div>

            <div className=" col-lg-4 col-md-6 mt-4">
              <span className="p-float-label">
                <NumberInput
                  name="late_interest"
                  max={100}
                  suffix="%"
                  errors={errors}
                  required={true}
                  disabled={loadingDiscData}
                  placeholder="0%"
                  label={
                    loadingDiscData ? "Carregando..." : "Juros Atraso (Ao mês)"
                  }
                  minFractionDigits={2}
                  maxFractionDigits={2}
                  control={form.control}
                />
              </span>
            </div>
          </div>
        </div>
        <div className="flex align-items-center mt-5">
          <h3 className="vertical-align-middle text-success">
            Descontos Boleto <i className="bi bi-currency-exchange"></i>
          </h3>
        </div>
        <div className="row">
          <div>
            <p>
              Configurações de Desconto no Boleto
              <Tooltip target=".custom-target-icon" />
              <i
                className="custom-target-icon pi pi-info-circle mx-2 p-text-secondary"
                data-pr-tooltip="Caso queira dar algum desconto até a data de vencimento, selecione quantos dias antes do vencimento e o percentual ou valor fixo de desconto."
                style={{ cursor: "pointer" }}
              ></i>
            </p>
          </div>
          <div className="row">
            <div className="col-xl-3 col-lg-3 col-md-12 d-flex justify-content-between">
              <div className="pt-4">
                <RadioButton
                  inputId="ingredient1"
                  name="percent"
                  value="1"
                  checked={radioButton === "1"}
                  onChange={(e) => setRadioButton(e.value)}
                />
                <label htmlFor="ingredient1" className="mx-2">
                  Percentual
                </label>
              </div>
              <div className="pt-4">
                <RadioButton
                  inputId="ingredient1"
                  name="value"
                  value="2"
                  checked={radioButton === "2"}
                  onChange={(e) => setRadioButton(e.value)}
                />
                <label htmlFor="ingredient1" className="mx-2">
                  Valor Fixo
                </label>
              </div>
            </div>
          </div>

          <div className="row mt-4">
            <div className="col-md-3">
              <NumberInput
                name="value_discount"
                suffix={radioButton === "1" && "%"}
                prefix={radioButton === "0" && "R$"}
                placeholder={radioButton === "1" ? "0%" : "0"}
                max={100}
                // required={true}
                control={form.control}
                errors={errors}
                label={
                  radioButton === "1" ? "% Desconto" : "Valor Fixo Desconto"
                }
              />
            </div>

            <div className="col-lg-4 col-md-5 mt-4">
              <span className="p-float-label">
                <NumberInput
                  name="days_discount_payment_slip"
                  // required={true}
                  control={form.control}
                  errors={errors}
                  label={"Dias para Desconto Antes do Vencimento"}
                  max={99}
                  maxLength={2}
                />
              </span>
            </div>
          </div>
        </div>
        {permissions &&
          permissions.includes("183") && ( //Cadastro por Planilhas
            <>
              <div className="flex align-items-center mt-5">
                <h3 className="vertical-align-middle text-success">
                  Comissão Geral <i className="bi bi-currency-exchange"></i>
                </h3>
              </div>

              <div className="row">
                <div>
                  <p>
                    Defina o percentual geral de comissão do empreendimento
                    <Tooltip target=".custom-target-icon" />
                    <i
                      className="custom-target-icon pi pi-info-circle mx-2 p-text-secondary"
                      data-pr-tooltip="Será calculado com base no valor total do lote."
                      style={{ cursor: "pointer" }}
                    ></i>
                  </p>
                </div>

                <div className="row ">
                  <div className="col-md-3">
                    <NumberInput
                      name="value_commission"
                      suffix={radioButton === "1" && "%"}
                      placeholder={radioButton === "1" ? "0%" : "0"}
                      max={100}
                      control={form.control}
                      errors={errors}
                      label="% Comissão"
                      onBlur={(e) =>
                        handleBlur(e.target.value.replace("%", "").trim())
                      }
                    />
                  </div>
                </div>
              </div>
            </>
          )}
        {/* <div className="flex align-items-center mt-5">
          <h3 className="vertical-align-middle text-success">
            Descontos Boleto <i className="bi bi-currency-exchange"></i>
          </h3>
        </div>
        <div className="row">
          <div>
            <p>
              Configurações de Desconto no Boleto
              <Tooltip target=".custom-target-icon" />
              <i
                className="custom-target-icon pi pi-info-circle mx-2 p-text-secondary"
                data-pr-tooltip="Caso queira dar algum desconto até a data de vencimento, selecione quantos dias antes do vencimento e o percentual ou valor fixo de desconto."
                style={{ cursor: "pointer" }}
              ></i>
            </p>
          </div>
          <div className="row">
            <div className="col-md-3 d-flex justify-content-between">
              <div className="pt-4">
                <RadioButton
                  inputId="ingredient1"
                  name="percent"
                  value="1"
                  checked={radioButton === "1"}
                  onChange={(e) => setRadioButton(e.value)}
                />
                <label htmlFor="ingredient1" className="mx-2">
                  Percentual
                </label>
              </div>
              <div className="pt-4">
                <RadioButton
                  inputId="ingredient1"
                  name="value"
                  value="2"
                  checked={radioButton === "2"}
                  onChange={(e) => setRadioButton(e.value)}
                />
                <label htmlFor="ingredient1" className="mx-2">
                  Valor Fixo
                </label>
              </div>
            </div>
          </div>

          <div className="row mt-4">
            <div className="col-md-3">
              <NumberInput
                name="value_discount"
                suffix={radioButton === "1" && "%"}
                prefix={radioButton === "0" && "R$"}
                placeholder={radioButton === "1" ? "0%" : "0"}
                max={100}
                control={form.control}
                errors={errors}
                label={
                  radioButton === "1" ? "% Min. Entrada" : "Valor Fixo Entrada"
                }
              />
            </div>

            <div className="col-md-4 mt-4">
              <span className="p-float-label">
                <NumberInput
                  name="days_discount_payment_slip"
                  max={100}
                  control={form.control}
                  errors={errors}
                  label={"Dias para Desconto Antes do Vencimento"}
                />
              </span>
            </div>
          </div>
        </div> */}
        <hr className="my-4" />
        <div className="col-md-12 d-flex justify-content-end">
          <div>
            <Button
              rounded
              type="submit"
              iconPos="right"
              label="Editar"
              icon="fa-solid fa-circle-chevron-right"
              className="p-inputtext-sm m-auto"
              loading={loading}
            />
          </div>
        </div>
      </form>
      <ModalCreateCurrentAccount
        visible={createAccVisible}
        headerModal={"Cadastrar"}
        handleCloseModal={() => setCreateAccVisible(false)}
        setVisible={setCreateAccVisible}
        owners={owners}
        refresh={refetchAccs}
        loadingAccount={setLoading}
      />
      <ModalCommisionGeral
        visible={isModalVisible}
        onHide={() => setModalVisible(false)}
        commissionData={commissionData}
      />
    </>
  );
}
